import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { useBootstrap } from '@/lib/useBootstrap';

/** Top-bar entry for What's New — freed a permanent sidebar slot (iter 512). */
export default function WhatsNewButton({ mobile = false }) {
  const boot = useBootstrap(true);
  const count = boot.data?.feature_updates_unread || 0;

  return (
    <Link to="/app/whats-new" title="What's New" data-testid={mobile ? "whats-new-topbar-btn-mobile" : "whats-new-topbar-btn"}
      className="relative flex items-center justify-center w-8 h-8 rounded-lg bg-white/[0.02] border border-white/[0.05] text-slate-400 hover:text-sky-300 hover:border-sky-500/30 transition-colors">
      <Sparkles className="w-4 h-4" />
      {count > 0 && (
        <span className="absolute -top-1 -right-1 min-w-[16px] h-[16px] flex items-center justify-center rounded-full bg-sky-500 text-white text-[10px] font-bold px-1"
          data-testid="whats-new-badge">{count}</span>
      )}
    </Link>
  );
}
